import { AT } from '../../../actions/actionTypes';
import { State, initPL, SetItemsPL, SetModePL } from './model';
import { StateDefault } from './defaults';
import * as CallStatus from '../../../utils/callStatus';
import { UserInfoDefault, SelectMode, UserInfo } from '../../../models';
import { getMode } from './utils';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

const defaultState: State = StateDefault;

export default function (state = defaultState, action: any) {
  switch (action.type) {
    case AT.DIALOG_READRIGHTS_INIT: {
      Logger.info([AT.DIALOG_READRIGHTS_INIT, action], LogArea.Redux);
      const { keys, groupedBy, mode }: initPL = action.payload;
      const addressee = { ...UserInfoDefault };
      const isConfirmed = false;
      return { ...state, keys, groupedBy, mode, addressee,isConfirmed };
    }

    case AT.DIALOG_READRIGHTS_SETCONFIRMED: {
      const isConfirmed: boolean = action.payload;
      return { ...state, isConfirmed };
    }

    case AT.DIALOG_READRIGHTS_SETITEMS: {
      Logger.info([AT.DIALOG_DOWNLOAD_SETITEMS, action], LogArea.Redux);
      const { keys }: SetItemsPL = action.payload;
      const mode =
        state.mode === SelectMode.Specific
          ? state.mode
          : getMode(state.groupedBy, keys);
      return { ...state, keys, mode };
    }

    case AT.DIALOG_READRIGHTS_SETMODE: {
      Logger.info([AT.DIALOG_DOWNLOAD_SETMODE, action], LogArea.Redux);
      const { groupedBy, mode }: SetModePL = action.payload;
      return { ...state, groupedBy, mode };
    }

    case AT.DIALOG_READRIGHTS_UPDATE_ASSIGNEE: {
      Logger.info(
        [AT.DIALOG_READRIGHTS_UPDATE_ASSIGNEE, action],
        LogArea.Redux
      );
      const addressee: UserInfo = action.payload;
      return { ...state, addressee };
    }

    case AT.DIALOG_READRIGHTS_ASSIGN_FETCH: {
      Logger.info(
        [AT.DIALOG_READRIGHTS_ASSIGN_FETCH, action],
        LogArea.Redux
      );
      const assignCall = CallStatus.fetch(state.assignCall);
      return { ...state, assignCall };
    }

    case AT.DIALOG_READRIGHTS_ASSIGN_SUCCESS: {
      Logger.info(
        [AT.DIALOG_READRIGHTS_ASSIGN_SUCCESS, action],
        LogArea.Redux
      );
      const assignCall = CallStatus.success(state.assignCall);
      return { ...state, assignCall };
    }

    case AT.DIALOG_READRIGHTS_ASSIGN_ERROR: {
      Logger.info(
        [AT.DIALOG_READRIGHTS_ASSIGN_ERROR, action],
        LogArea.Redux
      );
      const assignCall = CallStatus.error(state.assignCall, '');
      return { ...state, assignCall };
    }

    case AT.DIALOG_READRIGHTS_REMOVE_FETCH: {
      Logger.info(
        [AT.DIALOG_READRIGHTS_REMOVE_FETCH, action],
        LogArea.Redux
      );
      const unassignCall = CallStatus.fetch(state.unassignCall);
      return { ...state, unassignCall };
    }

    case AT.DIALOG_READRIGHTS_REMOVE_SUCCESS: {
      Logger.info(
        [AT.DIALOG_READRIGHTS_REMOVE_SUCCESS, action],
        LogArea.Redux
      );
      const unassignCall = CallStatus.success(state.unassignCall);
      return { ...state, unassignCall };
    }

    case AT.DIALOG_READRIGHTS_REMOVE_ERROR: {
      Logger.info(
        [AT.DIALOG_READRIGHTS_REMOVE_ERROR, action],
        LogArea.Redux
      );
      const unassignCall = CallStatus.error(state.unassignCall, '');
      return { ...state, unassignCall };
    }

    default: {
      return state;
    }
  }
}
